/* Alba Stella — long-form product pages: packs, gallery, sticky add to cart, tabs, size guide, cross-sell.
   Needs alba-theme.js (window.Alba). Owner: P. */
(function () {
  'use strict';
  var C = window.Alba || {};
  var qs = C.qs, qsa = C.qsa;
  if (!qs || !qsa) return;
  var money = function (cents) { return C.formatMoney ? C.formatMoney(cents) : '€' + (cents / 100).toFixed(2).replace('.', ','); };
  // Pack amounts like Curvd and Liquid's money_without_trailing_zeros: "€59" on whole euros, "€119,90" otherwise.
  var packMoney = function (cents) { var t = money(cents); return cents % 100 === 0 ? t.replace(/[.,]00(?!\d)/, '') : t; };
  var isDesktop = function () { return window.matchMedia('(min-width: 769px)').matches; };
  var findVariant = C.findVariant || function (product, opts) {
    for (var i = 0; i < product.variants.length; i++) {
      var v = product.variants[i], ok = true;
      for (var j = 0; j < opts.length; j++) { if (opts[j] != null && v.options[j] !== opts[j]) { ok = false; break; } }
      if (ok) return v;
    }
    return null;
  };
  function esc(s) { return String(s).replace(/&/g, '&amp;').replace(/"/g, '&quot;').replace(/</g, '&lt;').replace(/>/g, '&gt;'); }
  function readJSON(el) { try { return JSON.parse(el.textContent); } catch (e) { return null; } }

  /* ---------- Gallery slider (loop, drag, arrows, thumbs) ---------- */
  function Slider(root, onChange) {
    var viewport = qs('.pdp-gallery__viewport', root);
    var track = qs('[data-slider-track]', root);
    if (!viewport || !track) return null;
    var slides = qsa('[data-slide]', track);
    var n = slides.length;
    var api = { go: function () {}, index: 0 };
    if (n < 2) return api;
    var CL = Math.min(2, n);
    function clone(el) { var c = el.cloneNode(true); c.classList.add('is-clone'); c.removeAttribute('data-slide'); c.setAttribute('aria-hidden', 'true'); qsa('video', c).forEach(function (v) { v.removeAttribute('autoplay'); }); return c; }
    for (var i = 0; i < CL; i++) track.insertBefore(clone(slides[n - 1 - i]), track.firstChild);
    for (var j = 0; j < CL; j++) track.appendChild(clone(slides[j]));
    var index = 0, step = 0, offset = 0, busy = false;
    function measure() {
      var w = slides[0].getBoundingClientRect().width;
      var cs = getComputedStyle(track);
      var gap = parseFloat(cs.columnGap) || parseFloat(cs.gap) || 0;
      step = w + gap;
      offset = (viewport.clientWidth - w) / 2;
    }
    function pos(i) { return -(i + CL) * step + offset; }
    function set(i, anim, extra) {
      track.style.transition = anim ? 'transform .4s ease' : 'none';
      track.style.transform = 'translate3d(' + (pos(i) + (extra || 0)) + 'px,0,0)';
    }
    function norm(i) { return ((i % n) + n) % n; }
    function go(i, anim) {
      if (anim === undefined) anim = true;
      index = i;
      busy = anim;
      set(index, anim);
      api.index = norm(index);
      if (onChange) onChange(api.index);
      if (!anim) busy = false;
    }
    track.addEventListener('transitionend', function (e) {
      if (e.target !== track) return;
      busy = false;
      if (index < 0 || index >= n) { index = norm(index); set(index, false); }
    });
    // drag / swipe
    var startX = 0, startY = 0, dx = 0, dragging = false, decided = false, horizontal = false;
    function down(x, y) { if (busy) { index = norm(index); set(index, false); busy = false; } startX = x; startY = y; dx = 0; dragging = true; decided = false; horizontal = false; }
    function move(x, y, ev) {
      if (!dragging) return;
      var mx = x - startX, my = y - startY;
      if (!decided) { if (Math.abs(mx) < 6 && Math.abs(my) < 6) return; decided = true; horizontal = Math.abs(mx) > Math.abs(my); }
      if (!horizontal) return;
      if (ev && ev.cancelable) ev.preventDefault();
      dx = mx; track.classList.add('is-dragging'); set(index, false, dx);
    }
    function up() {
      if (!dragging) return;
      dragging = false; track.classList.remove('is-dragging');
      if (!horizontal) return;
      if (dx < -40) go(index + 1); else if (dx > 40) go(index - 1); else go(index);
    }
    track.addEventListener('touchstart', function (e) { var t = e.touches[0]; down(t.clientX, t.clientY); }, { passive: true });
    track.addEventListener('touchmove', function (e) { var t = e.touches[0]; move(t.clientX, t.clientY, e); }, { passive: false });
    track.addEventListener('touchend', up);
    track.addEventListener('mousedown', function (e) { e.preventDefault(); down(e.clientX, e.clientY); });
    window.addEventListener('mousemove', function (e) { if (dragging) move(e.clientX, e.clientY, null); });
    window.addEventListener('mouseup', up);
    track.addEventListener('click', function (e) { if (Math.abs(dx) > 6) { e.preventDefault(); e.stopPropagation(); } }, true);
    var prev = qs('[data-slider-prev]', root), next = qs('[data-slider-next]', root);
    if (prev) prev.addEventListener('click', function () { go(index - 1); });
    if (next) next.addEventListener('click', function () { go(index + 1); });
    function refresh() { measure(); set(index, false); }
    window.addEventListener('resize', refresh);
    if (document.readyState === 'complete') refresh(); else window.addEventListener('load', refresh);
    refresh();
    api.go = function (i, anim) { go(i, anim); };
    return api;
  }

  /* ---------- Landing PDP ---------- */
  qsa('[data-pdp]').forEach(function (pdp) {
    var jsonEl = qs('[data-product-json]', pdp);
    var product = jsonEl ? readJSON(jsonEl) : null;
    if (!product) return;
    var discount = parseInt(pdp.getAttribute('data-discount'), 10) || 0;
    var minQty = parseInt(pdp.getAttribute('data-min-qty'), 10) || 2;
    var colorDots = pdp.getAttribute('data-color-dots') === 'true';
    var form = qs('[data-pdp-form]', pdp);
    var atc = qs('[data-pdp-atc]', pdp);
    var errorEl = qs('[data-pdp-error]', pdp);
    var options = product.options || [];
    var swatches = product.swatches || {};
    var firstAvail = product.variants.filter(function (v) { return v.available; })[0] || product.variants[0];
    // Every pack row starts on product.selected_or_first_available_variant (the form's id), so a ?variant= link
    // preselects its colour, size and length. Without the parameter that is the first available variant, as before.
    var idInput = form && qs('input[name="id"]', form);
    var initial = (idInput && product.variants.filter(function (v) { return String(v.id) === idInput.value; })[0]) || firstAvail;

    /* Prices. Curvd-style packs (data-pack-off "2:6090,3:9485,"): a fixed amount off once per order, the highest tier whose
       quantity is reached, like the store's automatic discounts "Pakket N". Otherwise the old percentage: Shopify floors the
       automatic discount per unit (checked against /cart.js). */
    var packOff = [];
    (pdp.getAttribute('data-pack-off') || '').split(',').forEach(function (t) {
      var kv = t.split(':');
      if (kv.length === 2 && kv[0] !== '') packOff.push({ min: parseInt(kv[0], 10) || 0, off: parseInt(kv[1], 10) || 0 });
    });
    function offFor(n) {
      var best = 0, bestMin = 0;
      packOff.forEach(function (t) { if (t.min <= n && t.min > bestMin) { bestMin = t.min; best = t.off; } });
      return best;
    }
    function unitPay(price) { return price - Math.floor(price * discount / 100); }
    function packTotals(list) {
      var compare = 0, total = 0;
      list.forEach(function (v) { compare += v.price; });
      if (packOff.length) total = Math.max(0, compare - offFor(list.length));
      else if (list.length >= minQty && discount > 0) list.forEach(function (v) { total += unitPay(v.price); });
      else total = compare;
      return { total: total, compare: compare, save: compare - total, n: list.length };
    }
    function paint(opt, t) {
      var p = qs('[data-pack-price]', opt), c = qs('[data-pack-compare]', opt), s = qs('[data-pack-save]', opt), per = qs('[data-pack-per]', opt);
      if (p) p.textContent = packMoney(t.total);
      if (c) { c.textContent = packMoney(t.compare); c.hidden = t.save <= 0; }
      if (s) { s.textContent = 'BESPAAR ' + packMoney(t.save); s.hidden = t.save <= 0; }
      // Price per piece of the pack (hero setting pack_unit_text, "{prijs}").
      if (per && t.n) per.textContent = (per.getAttribute('data-per-template') || '').replace('{prijs}', packMoney(Math.round(t.total / t.n)));
    }

    // Option names: Maat / Kleur / Pijplengte (Spanish and English names still recognised).
    function fieldClass(name) {
      var n = (name || '').toLowerCase();
      if (n.indexOf('lengte') > -1 || n.indexOf('largo') > -1 || n.indexOf('inseam') > -1) return 'w3';
      if (n.indexOf('maat') > -1 || n.indexOf('talla') > -1 || n.indexOf('size') > -1) return 'w1';
      return 'w2';
    }
    function isColor(name) { var n = (name || '').toLowerCase(); return n.indexOf('kleur') > -1 || n.indexOf('color') > -1 || n.indexOf('colour') > -1; }
    function unitRow(index, preset) {
      var row = document.createElement('div');
      row.className = 'pdp-unit';
      row.setAttribute('data-unit', index);
      var html = '<img class="pdp-unit__img" alt="" width="32" height="40" src="' + esc(preset.image || '') + '">';
      html += '<div class="pdp-unit__selects">';
      options.forEach(function (name, oi) {
        var values = [];
        product.variants.forEach(function (v) { if (values.indexOf(v.options[oi]) === -1) values.push(v.options[oi]); });
        var dot = colorDots && isColor(name);
        html += '<label class="pdp-unit__field pdp-unit__field--' + fieldClass(name) + (dot ? ' pdp-unit__field--dot' : '') + '">';
        html += '<span class="visually-hidden">' + esc(name) + ' (stuk ' + (index + 1) + ')</span>';
        if (dot) html += '<span class="pdp-unit__dot" data-unit-dot></span>';
        html += '<select class="pdp-unit__select" data-unit-opt="' + oi + '">';
        values.forEach(function (val) { html += '<option value="' + esc(val) + '"' + (preset.options[oi] === val ? ' selected' : '') + '>' + esc(val) + '</option>'; });
        html += '</select></label>';
      });
      html += '</div>';
      row.innerHTML = html;
      return row;
    }
    function rowVariant(row) {
      var opts = qsa('[data-unit-opt]', row).map(function (s) { return s.value; });
      return findVariant(product, opts);
    }
    function refreshUnit(row) {
      var opts = qsa('[data-unit-opt]', row).map(function (s) { return s.value; });
      var v = findVariant(product, opts);
      var img = qs('.pdp-unit__img', row);
      if (v && v.image && img) img.src = v.image;
      qsa('[data-unit-opt]', row).forEach(function (sel, oi) {
        qsa('option', sel).forEach(function (o) {
          var test = opts.slice(); test[oi] = o.value;
          var tv = findVariant(product, test);
          o.textContent = (tv && !tv.available) ? o.value + ' - Uitverkocht' : o.value;
        });
        if (colorDots && isColor(options[oi])) {
          var dot = qs('[data-unit-dot]', sel.parentNode);
          if (dot) dot.style.setProperty('--dot', swatches[sel.value] || '#d9d4cc');
        }
      });
      row.classList.toggle('is-unavailable', !(v && v.available));
    }
    function selectedOption() { var c = qs('[data-bundle-option] input:checked', pdp); return c ? c.closest('[data-bundle-option]') : null; }
    function updatePrices() {
      qsa('[data-bundle-option]', pdp).forEach(function (opt) {
        var qty = parseInt(opt.getAttribute('data-qty'), 10) || 1;
        var list = [];
        var rows = qsa('.pdp-unit', opt);
        if (opt.classList.contains('is-selected') && rows.length) {
          rows.forEach(function (r) { list.push(rowVariant(r) || initial); });
        } else {
          for (var i = 0; i < qty; i++) list.push(initial);
        }
        paint(opt, packTotals(list));
      });
    }
    var lastChoices = [];
    pdp.addEventListener('change', function (e) {
      if (e.target.matches('[data-bundle-option] input')) {
        // keep the sizes/colours already chosen when switching packs
        var prevRows = qsa('.pdp-unit', pdp);
        if (prevRows.length) lastChoices = prevRows.map(function (r) { return rowVariant(r); });
        renderUnitsWith(lastChoices);
      }
      if (e.target.matches('[data-unit-opt]')) { refreshUnit(e.target.closest('.pdp-unit')); updatePrices(); }
    });
    function renderUnitsWith(choices) {
      qsa('[data-bundle-option]', pdp).forEach(function (opt) {
        var input = qs('input', opt);
        var units = qs('[data-bundle-units]', opt);
        opt.classList.toggle('is-selected', input.checked);
        units.innerHTML = '';
        if (!input.checked) return;
        var qty = parseInt(input.value, 10);
        for (var i = 0; i < qty; i++) { var r = unitRow(i, (choices && choices[i]) || initial); units.appendChild(r); refreshUnit(r); }
      });
      updatePrices();
    }
    renderUnitsWith([]);

    function collectItems() {
      var opt = selectedOption();
      var qty = opt ? parseInt(opt.getAttribute('data-qty'), 10) : 1;
      var rows = opt ? qsa('.pdp-unit', opt) : [];
      var map = {}, order = [];
      if (!rows.length) { map[initial.id] = qty; order.push(initial.id); }
      rows.forEach(function (row) {
        var v = rowVariant(row);
        if (!v) return;
        if (!map[v.id]) { map[v.id] = 0; order.push(v.id); }
        map[v.id] += 1;
      });
      return order.map(function (id) { return { id: id, quantity: map[id] }; });
    }
    var stickyBtn = qs('[data-sticky-atc]', pdp);
    function submit() {
      if (errorEl) errorEl.hidden = true;
      if (qsa('.pdp-unit.is-unavailable', pdp).length) {
        if (errorEl) { errorEl.textContent = 'Een van de gekozen combinaties is uitverkocht. Kies een andere maat of kleur.'; errorEl.hidden = false; }
        if (!isElementVisible(atc)) atc.scrollIntoView({ behavior: 'smooth', block: 'center' });
        return;
      }
      atc.disabled = true; if (stickyBtn) stickyBtn.disabled = true;
      C.addItems(collectItems())
        .then(function () { return C.refreshCart(true); })
        .catch(function (err) { if (errorEl) { errorEl.textContent = err.message; errorEl.hidden = false; } })
        .then(function () { atc.disabled = false; if (stickyBtn) stickyBtn.disabled = false; });
    }
    function isElementVisible(el) { var r = el.getBoundingClientRect(); return r.top >= 0 && r.bottom <= window.innerHeight; }
    if (form) form.addEventListener('submit', function (e) { e.preventDefault(); submit(); });
    if (stickyBtn) stickyBtn.addEventListener('click', submit);

    // Sticky bar: shown once the main button has scrolled above the viewport (less than 10 % of it left
    // below a 20 px top margin), hidden while it is visible. Checked on scroll so jumps (anchors, restored
    // scroll positions) are handled too.
    var sticky = qs('[data-pdp-sticky]', pdp);
    if (sticky && atc) {
      var shown = null;
      var checkSticky = function () {
        var r = atc.getBoundingClientRect();
        var visible = Math.max(0, Math.min(r.bottom, window.innerHeight) - Math.max(r.top, 20));
        var show = r.top < 0 && visible < r.height * 0.1;
        if (show === shown) return;
        shown = show;
        sticky.classList.toggle('is-visible', show);
        sticky.setAttribute('aria-hidden', show ? 'false' : 'true');
      };
      window.addEventListener('scroll', checkSticky, { passive: true });
      window.addEventListener('resize', checkSticky);
      checkSticky();
    }

    // Gallery
    var thumbs = qsa('[data-thumb]', pdp);
    var thumbList = qs('[data-thumb-list]', pdp);
    var tPrev = qs('[data-thumbs-prev]', pdp), tNext = qs('[data-thumbs-next]', pdp);
    // The thumbnail list is vertical on desktop and, on the sherpa layout, a horizontal strip on phones.
    function thumbsRow() { return thumbList && getComputedStyle(thumbList).flexDirection === 'row'; }
    function thumbStep() {
      if (!thumbs[0]) return 117;
      var r = thumbs[0].getBoundingClientRect(), cs = getComputedStyle(thumbList);
      return thumbsRow() ? (r.width + (parseFloat(cs.columnGap) || 0)) * 2 : r.height + (parseFloat(cs.rowGap) || 0);
    }
    function updateThumbNav() {
      if (!thumbList) return;
      var row = thumbsRow();
      var pos = row ? thumbList.scrollLeft : thumbList.scrollTop;
      var max = row ? thumbList.scrollWidth - thumbList.clientWidth - 2 : thumbList.scrollHeight - thumbList.clientHeight - 2;
      if (tPrev) tPrev.disabled = pos <= 1;
      if (tNext) tNext.disabled = pos >= max;
    }
    var sliderRoot = qs('[data-pdp-slider]', pdp);
    var slider = Slider(sliderRoot, function (i) {
      thumbs.forEach(function (t, k) { t.classList.toggle('is-active', k === i); });
      var t = thumbs[i];
      if (t && thumbList && thumbList.offsetParent) {
        if (thumbsRow()) {
          var left = t.offsetLeft - thumbList.offsetLeft, w = t.offsetWidth;
          if (left < thumbList.scrollLeft) thumbList.scrollLeft = left;
          else if (left + w > thumbList.scrollLeft + thumbList.clientWidth) thumbList.scrollLeft = left + w - thumbList.clientWidth;
        } else {
          var top = t.offsetTop, h = t.offsetHeight;
          if (top < thumbList.scrollTop) thumbList.scrollTop = top;
          else if (top + h > thumbList.scrollTop + thumbList.clientHeight) thumbList.scrollTop = top + h - thumbList.clientHeight;
        }
      }
    });
    thumbs.forEach(function (t) { t.addEventListener('click', function () { if (slider) slider.go(parseInt(t.getAttribute('data-thumb'), 10)); }); });
    if (thumbList) {
      if (tPrev) tPrev.addEventListener('click', function () { if (thumbsRow()) thumbList.scrollLeft -= thumbStep(); else thumbList.scrollTop -= thumbStep(); });
      if (tNext) tNext.addEventListener('click', function () { if (thumbsRow()) thumbList.scrollLeft += thumbStep(); else thumbList.scrollTop += thumbStep(); });
      thumbList.addEventListener('scroll', updateThumbNav, { passive: true });
      window.addEventListener('resize', updateThumbNav);
      updateThumbNav();
    }
    // A ?variant= link opens the gallery on that variant's photo (data-start is only set for a URL variant).
    var start = sliderRoot ? parseInt(sliderRoot.getAttribute('data-start'), 10) || 0 : 0;
    if (slider && start > 0) { slider.go(start, false); updateThumbNav(); }

    // Size guide
    var sizeModal = qs('[data-pdp-size-modal]', pdp);
    if (sizeModal) {
      document.body.appendChild(sizeModal);
      qsa('[data-pdp-size-open]', pdp).forEach(function (b) {
        b.addEventListener('click', function (e) { e.preventDefault(); if (C.openModal) C.openModal(sizeModal); });
      });
    }

    // Cross-sell card
    qsa('[data-pdp-xsell]', pdp).forEach(function (box) {
      var data = readJSON(qs('[data-xsell-json]', box));
      if (!data) return;
      var base = box.getAttribute('data-url');
      var sels = qsa('[data-xsell-opt]', box);
      function upd() {
        var v = findVariant(data, sels.map(function (s) { return s.value; }));
        if (!v) return;
        var pr = qs('[data-xsell-price]', box); if (pr) pr.textContent = money(v.price);
        qsa('[data-xsell-link]', box).forEach(function (a) { a.href = base + '?variant=' + v.id; });
      }
      sels.forEach(function (s) { s.addEventListener('change', upd); });
    });

    // Complete-your-look cards
    qsa('[data-pdp-look]', pdp).forEach(function (card) {
      var data = readJSON(qs('[data-look-json]', card));
      if (!data) return;
      var sels = qsa('[data-look-opt]', card);
      var btn = qs('[data-look-add]', card);
      function cur() { return findVariant(data, sels.map(function (s) { return s.value; })); }
      // The photo follows the chosen colour: the variant's own image (from the product's .js data); back on the starting
      // colour the card's own photo returns.
      var im = qs('.pdp-look__img img', card);
      var link = qs('.pdp-look__img', card);
      var orig = im ? { src: im.getAttribute('src'), srcset: im.getAttribute('srcset') } : null;
      var vImg = null, startImg = null;
      function sized(u) { return u ? u.replace(/^https?:/, '') + (u.indexOf('?') > -1 ? '&' : '?') + 'width=372&height=372&crop=center' : null; }
      function swapImg(v) {
        if (!im || !v || !vImg) return;
        var u = vImg[v.id];
        if (!u || u === startImg) {
          if (im.getAttribute('src') !== orig.src) { im.setAttribute('src', orig.src); if (orig.srcset) im.setAttribute('srcset', orig.srcset); }
          return;
        }
        if (im.getAttribute('src') === u) return;
        im.removeAttribute('srcset');
        im.setAttribute('src', u);
      }
      if (im && link && window.fetch) {
        fetch(link.getAttribute('href').split('?')[0] + '.js', { credentials: 'same-origin' }).then(function (r) { return r.ok ? r.json() : null; }).then(function (p) {
          if (!p || !p.variants) return;
          vImg = {};
          p.variants.forEach(function (x) { vImg[x.id] = x.featured_image ? sized(x.featured_image.src) : null; });
          var v0 = cur(); startImg = v0 ? vImg[v0.id] : null;
        }).catch(function () {});
      }
      function upd() {
        var v = cur();
        var pr = qs('[data-look-price]', card); if (pr && v) pr.textContent = money(v.price);
        if (btn) btn.disabled = !(v && v.available);
        swapImg(v);
      }
      sels.forEach(function (s) { s.addEventListener('change', upd); });
      if (btn) btn.addEventListener('click', function () {
        var v = cur(); if (!v || !v.available) return;
        btn.disabled = true;
        C.addItems([{ id: v.id, quantity: 1 }]).then(function () { return C.refreshCart(true); }).catch(function () {}).then(function () { btn.disabled = false; });
      });
      upd();
    });

    // Videos (only real videos)
    qsa('[data-pdp-video]', pdp).forEach(function (b) {
      b.addEventListener('click', function () {
        var v = qs('video', b.parentNode); if (!v) return;
        if (v.paused) { v.muted = false; v.play(); b.classList.add('is-playing'); } else { v.pause(); b.classList.remove('is-playing'); }
      });
    });
  });

  /* ---------- Tabs (buy box and stand-alone sections) ---------- */
  qsa('[data-pdp-tabs]').forEach(function (tabs) {
    var btns = qsa('[data-tab-btn]', tabs);
    btns.forEach(function (btn) {
      btn.addEventListener('click', function () {
        var i = btn.getAttribute('data-tab-btn');
        btns.forEach(function (b) { b.classList.toggle('is-active', b === btn); b.setAttribute('aria-selected', b === btn ? 'true' : 'false'); });
        qsa('[data-tab-panel]', tabs).forEach(function (p) { p.hidden = p.getAttribute('data-tab-panel') !== i; });
      });
    });
  });

  /* ---------- Fact strip: one fact per view on phones ---------- */
  qsa('[data-pdp-strip]').forEach(function (strip) {
    var track = qs('[data-strip-track]', strip);
    var items = track ? track.children.length : 0;
    if (items < 2) return;
    var i = 0, paused = false;
    strip.addEventListener('mouseenter', function () { paused = true; });
    strip.addEventListener('mouseleave', function () { paused = false; });
    setInterval(function () {
      if (paused || isDesktop()) { if (isDesktop()) track.style.transform = ''; return; }
      i = (i + 1) % items;
      track.style.transform = 'translateX(-' + (i * 100) + '%)';
    }, 2500);
  });

  /* ---------- Card carousels (reasons, reviews) ---------- */
  qsa('[data-pdp-carousel]').forEach(function (car) {
    var track = qs('[data-carousel-track]', car);
    if (!track) return;
    function step() { var item = track.firstElementChild; var gap = parseFloat(getComputedStyle(track).columnGap) || 0; return item ? item.getBoundingClientRect().width + gap : 300; }
    var prev = qs('[data-carousel-prev]', car), next = qs('[data-carousel-next]', car);
    if (prev) prev.addEventListener('click', function () { track.scrollBy({ left: -step(), behavior: 'smooth' }); });
    if (next) next.addEventListener('click', function () { track.scrollBy({ left: step(), behavior: 'smooth' }); });
  });

  /* ---------- Marquee speed in px per second ---------- */
  qsa('[data-pdp-marquee]').forEach(function (m) {
    var track = qs('.pdp-band__track', m);
    var group = track && track.firstElementChild;
    var pps = parseFloat(m.getAttribute('data-pps')) || 40;
    function setSpeed() { if (group) track.style.animationDuration = (group.getBoundingClientRect().width / pps).toFixed(2) + 's'; }
    setSpeed(); window.addEventListener('resize', setSpeed);
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(setSpeed);
  });

  /* ---------- Buttons that scroll back to the pack selector ---------- */
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-pdp-scroll-top]');
    if (!b) return;
    var target = qs('[data-bundle]') || qs('[data-pdp]') || qs('[data-product-form]') || qs('#MainContent');
    if (!target) return;
    e.preventDefault();
    window.scrollTo({ top: target.getBoundingClientRect().top + window.pageYOffset - 120, behavior: 'smooth' });
  });
})();
